enum PricePlanVisibility {
    INTERNAL = 'internal',
    PUBLIC = 'public',
}

export default PricePlanVisibility;
